var _defs, _path, _path2, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCierrepasoDiagonal2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 594.4 598.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #a00707;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.9,129.1l-229.7.4c-4.5-9.6-2-15.4,4.4-23.1,26.1-31.2,63.2-59.3,90.4-90.2,3.2-4,17.5-4.5,20.1-1.8l114.6,114.6h.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.8,474.9c26.6,2.4,219.6-6.5,228.3.8,6.8,5.8,1.6,16.3-3,21.7-25.6,31.1-63.6,59.3-90.6,90.2-3,4-17.4,4.5-20,1.9l-114.6-114.6h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "148.5 269.6 156 267.1 376.9 267.2 437.9 328.2 207.9 329 148.5 269.6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "248.9 370 256.4 367.5 477.2 367.5 536.6 426.9 529 429.4 308.3 429.4 248.9 370"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "48.1 169.3 278.2 168.5 337.5 227.8 107.5 228.7 48.1 169.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCierrepasoDiagonal2);
export default __webpack_public_path__ + "static/media/CIERRE PASO-DIAGONAL 2.adfcd52d478ad840149a5d07835b22a5.svg";
export { ForwardRef as ReactComponent };